import React from "react";
import { Link } from 'react-router-dom';
import User from 'components/user';



const CollectionInfoField = ({ collection }) => {

    const { id, name, nickname } = collection?.author;

    return (
        <>
            <Link to={ `${ User.Const.basePath }/${ id }` }> { `${ name }` } <br /> { `${ nickname }` }</Link>
        </>
    )
}


export default CollectionInfoField;